var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('string-view',_vm._b({staticClass:"number-view",model:{value:(_vm.formatted),callback:function ($$v) {_vm.formatted=$$v},expression:"formatted"}},'string-view',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }